/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';

import { useFormHelpers } from '../../../hooks/useFormHelpers';
import { QuickSetupComponentProps } from '../../../util/types';
import { FIELDS } from '../schema';
import { PageStepMessages as messages } from './messages';
import { PageContent } from './PageContent';

export const PageStep = ({ markStepComplete }: QuickSetupComponentProps) => {
  const formMethods = useFormContext();
  const { isValidAndPopulated, updateFieldValue } = useFormHelpers(formMethods);

  useEffect(() => {
    updateFieldValue(FIELDS.VERIFICATION_TOKEN, uuidv4());
  }, [updateFieldValue]);

  // When field is valid, mark step complete and enable next button
  useEffect(() => {
    const isPageAccessTokenValid = isValidAndPopulated(
      FIELDS.PAGE_ACCESS_TOKEN
    );
    markStepComplete(isPageAccessTokenValid ?? false);
  }, [isValidAndPopulated, markStepComplete]);

  return (
    <div className="TabContent__body-content TabContent__body-outdent">
      <div className="QuickSetup__step-title">
        <FormattedMessage {...messages.title} />
      </div>
      <div className="TabContent__spacer8" />
      <PageContent isQuickSetup />
    </div>
  );
};
